import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { Observable } from 'rxjs';
import { FeatureToggleSettings } from '../featuresToggleSettings.model';
import { FeatureToggleState, FeatureToggleStore } from './feature-toggle-store';
import { AppConfigService } from 'app/services/appConfig/appConfigService';


@Injectable({ providedIn: 'root' })
export class FeatureToggleQuery extends Query<FeatureToggleState> {
	featureToggles$: Observable<FeatureToggleSettings[]> = this.select((state) => state.featureToggles);

	constructor(protected store: FeatureToggleStore, private appConfigService: AppConfigService) {
		super(store);
	}

	get featureToggles(): FeatureToggleSettings[] {
		return this.getValue().featureToggles;
	}

	get isFeatureTogglesUpdated() {
		const lastUpdateTime = new Date(this.getValue().lastUpdate).getTime();
		const timeNow = new Date().getTime();
		const shouldFetch = !this.getValue().lastUpdate || timeNow - lastUpdateTime > this.appConfigService.appSettings.cachingTimeout;
		return this.getValue().featureToggles.length > 0 && !shouldFetch;
	}
}
